import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '@app/shared';
import { VendorsModule } from './vendors/vendors.module';

@NgModule({
	declarations: [],
	imports: [CommonModule, SharedModule, VendorsModule],
})
export class AccountsPayableModule {}
